import api from '../index'

const {
  http,
  store
} = api

/**
 * ===================
 * Apply API
 * ===================
 */
export default {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v1`,
  url: 'applies',
  http,
  store,
  /**
   * Get all job applicants.
   *
   */
  search (params) {
    return this.http(this.baseUrl)
      .post(`${this.url}/search`, params)
  }
}
